export const UPDATE_PENDING_STOCK_REQUESTS_COUNT = 'UPDATE_PENDING_STOCK_REQUESTS_COUNT';

export const updatePendingStockRequestsCount = (count) => ({
    type: UPDATE_PENDING_STOCK_REQUESTS_COUNT,
    payload: count
});